import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Crown, UserPlus, UserMinus } from "lucide-react";
import { SiteHoursTable } from "@/components/etablissement/SiteHoursTable";
import { fullName } from "@/components/etablissement/shared";

export function SiteTeamTab({ site, salaries, unassigned, onAssign, onUnassign, onResponsable }) {
  const [pick, setPick] = useState("");
  return (
    <div className="space-y-5" data-testid="site-team-tab">
      <div className="grid md:grid-cols-2 gap-4">
        <div className="bg-[#F8F9FA] border border-[#DEE2E6] p-4">
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] mb-2 flex items-center gap-1.5"><Crown className="h-3 w-3 text-[#FFD700]" /> Responsable d'établissement</div>
          <Select value={site.responsable_id || "none"} onValueChange={(v) => onResponsable(v === "none" ? null : v)}>
            <SelectTrigger data-testid="site-responsable-select" className="h-10 bg-white"><SelectValue placeholder="Choisir un salarié" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="none">— Aucun responsable —</SelectItem>
              {salaries.map((s) => <SelectItem key={s.id} value={s.id}>{fullName(s)} · {s.code}</SelectItem>)}
            </SelectContent>
          </Select>
          <p className="text-[11px] text-[#495057] mt-2">Le responsable accède à « Mon établissement » depuis son espace salarié : équipe, planning, congés et statistiques de ce site uniquement.</p>
        </div>
        <div className="bg-[#F8F9FA] border border-[#DEE2E6] p-4">
          <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96] mb-2 flex items-center gap-1.5"><UserPlus className="h-3 w-3 text-[#002FA7]" /> Affecter un salarié</div>
          <div className="flex gap-2">
            <Select value={pick || "none"} onValueChange={(v) => setPick(v === "none" ? "" : v)}>
              <SelectTrigger data-testid="site-assign-select" className="h-10 bg-white flex-1"><SelectValue placeholder="Salarié non affecté" /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">— Choisir —</SelectItem>
                {unassigned.map((s) => <SelectItem key={s.id} value={s.id}>{fullName(s)} · {s.poste || s.code}</SelectItem>)}
              </SelectContent>
            </Select>
            <Button disabled={!pick} onClick={async () => { await onAssign(pick); setPick(""); }} data-testid="site-assign-btn" className="h-10 bg-[#002FA7] hover:bg-[#002175] text-white">Affecter</Button>
          </div>
          <p className="text-[11px] text-[#495057] mt-2">{unassigned.length} salarié{unassigned.length > 1 ? "s" : ""} sans établissement. Un salarié peut aussi être affecté depuis sa fiche.</p>
        </div>
      </div>
      <SiteHoursTable salaries={salaries} responsableId={site.responsable_id}
        renderActions={(s) => (
          <Button size="sm" variant="outline" onClick={() => onUnassign(s.id)} data-testid={`site-unassign-${s.code}`} className="h-8 px-2 border-[#E60000] text-[#E60000] hover:bg-[#E60000] hover:text-white" title="Retirer de l'établissement">
            <UserMinus className="h-3.5 w-3.5" />
          </Button>
        )} />
    </div>
  );
}
